import React from "react";
import "./PcaHowItWorks.css";

const features = [
  {
    title: "Pick your Porsche",
    description: "Over 450 Porsche model lines, from air-cooled to 992 and everything in between, drawn from 15,000+ auction results."
  },
  {
    title: "Dial in the spec",
    description: "Transmission, mileage, paint, interior, and the options that make a car special."
  },
  {
    title: "See your market",
    description: "Every comparable result plotted, so you see exactly where your car fits."
  },
  {
    title: "Get a real number",
    description: "A Price Guide built on actual comps, not asking prices or guesswork."
  },
  {
    title: "Watch the trend",
    description: "Compare the market to previous periods before it moves."
  },
  {
    title: "Save your searches",
    description: "Track your favorite models to see changes in the market and current live auctions."
  }
];

const PcaHowItWorks = () => (
  <section className="pca-how" id="how">
    <div className="pca-how__header">
      <div className="pca-how__badge">How It Works</div>
      <h2 className="pca-how__headline-main">The clarity the market hides from you</h2>
    </div>

    <div className="pca-how__grid">
      {features.map((feature, index) => (
        <div className="pca-how__card" key={feature.title}>
          <span className="pca-how__number">{String(index + 1).padStart(2, "0")}</span>
          <h3 className="pca-how__title">{feature.title}</h3>
          <p className="pca-how__description">{feature.description}</p>
        </div>
      ))}
    </div>
  </section>
);

export default PcaHowItWorks;
